<div [class]="field.styleValue">
    <span class="link-value">
      <a href="{{link.href}}" target="_blank">{{ link.text }}</a>
    </span>
</div>
